import { render, staticRenderFns } from "./CredentialEdit.vue?vue&type=template&id=4631b5c5"
import script from "./CredentialEdit.vue?vue&type=script&lang=ts"
export * from "./CredentialEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports